import { Translations } from './fr';

export const es: Translations = {
  nav: {
    home: "Inicio",
    primeEvolution: "Evolution",
    pulse: "Pulse",
    sparkle: "Sparkle",
    agents: "Agentes",
    partners: "Socios",
    contact: "Contacto",
    recruitAgent: "Reclutar Agente",
  },
  hero: {
    title: "Reclute nuestros",
    titleHighlight: "Agentes IA",
    titleEnd: "para Fortalecer sus Equipos",
    subtitle: "Colaboradores virtuales disponibles 24/7, formados en sus procesos de negocio, listos para transformar su productividad.",
    cta: "Reclutar un Agente IA",
    discover: "Descubrir Prime Evolution",
  },
  trust: {
    available: "Disponible 24/7",
    secure: "100% Seguro",
    agents: "Agentes Certificados",
    support: "Soporte Dedicado",
  },
  primeEvolution: {
    badge: "Nuestra Solución Estrella",
    title: "Prime Evolution",
    subtitle: "El programa de acompañamiento completo para integrar la IA en su empresa",
    description: "Prime Evolution es nuestro enfoque holístico que combina auditoría, formación y despliegue de agentes IA personalizados.",
    features: {
      audit: { title: "Auditoría Estratégica", description: "Análisis profundo de sus procesos para identificar oportunidades de automatización." },
      training: { title: "Formación de Equipos", description: "Programas de formación adaptados para colaboración efectiva con IA." },
      deployment: { title: "Despliegue Personalizado", description: "Agentes IA personalizados integrados con sus herramientas existentes." },
      support: { title: "Acompañamiento Continuo", description: "Soporte dedicado y optimización continua." },
    },
    cta: "Iniciar Prime Evolution",
    stats: { productivity: "Ganancia de productividad media", roi: "Retorno de inversión", satisfaction: "Tasa de satisfacción" },
  },
  pulse: {
    badge: "Automatización Inteligente",
    title: "VEECTORIA Pulse",
    subtitle: "Automatización que pulsa al ritmo de su empresa",
    description: "Pulse es nuestra plataforma de automatización inteligente que conecta y orquesta sus workflows en tiempo real.",
    features: {
      connect: { title: "Conecte", description: "Integración nativa con más de 200 herramientas profesionales." },
      orchestrate: { title: "Orqueste", description: "Workflows inteligentes que se adaptan automáticamente." },
      optimize: { title: "Optimice", description: "Análisis en tiempo real y recomendaciones de mejora." },
    },
    cta: "Descubrir Pulse",
  },
  advantages: {
    badge: "Por Qué Elegirnos",
    title: "Ventajas VEECTORIA",
    subtitle: "Un enfoque único que combina experiencia humana y potencia de la IA",
    items: {
      expertise: { title: "Experiencia Reconocida", description: "Más de 10 años de experiencia en transformación digital e IA." },
      custom: { title: "Soluciones Personalizadas", description: "Cada agente se entrena específicamente en sus procesos." },
      security: { title: "Seguridad Máxima", description: "Datos alojados en Europa, conformidad RGPD garantizada." },
      roi: { title: "ROI Garantizado", description: "Compromiso con resultados medibles." },
      support: { title: "Soporte 24/7", description: "Equipo dedicado disponible en todo momento." },
      evolution: { title: "Evolución Continua", description: "Sus agentes mejoran constantemente mediante machine learning." },
    },
  },
  sparkle: {
    badge: "Digitalización Inteligente",
    title: "Sparkle",
    subtitle: "TagPDF v7 con IA",
    description: "Transforme sus documentos en papel en datos utilizables con nuestra solución de digitalización inteligente. Reconocimiento automático, extracción de datos y clasificación inteligente.",
    features: {
      scan: {
        title: "Digitalización Avanzada",
        description: "OCR de alta precisión para todos los tipos de documentos.",
      },
      ai: {
        title: "IA Integrada",
        description: "Clasificación y extracción automática de datos clave.",
      },
      speed: {
        title: "Procesamiento Ultrarrápido",
        description: "Miles de páginas procesadas en minutos.",
      },
      accuracy: {
        title: "Máxima Precisión",
        description: "Tasa de reconocimiento superior al 99%.",
      },
    },
    cta: "Descubrir Sparkle",
    ctaFulltext: "Indexación Full-text",
    ctaFulltextDesc: "Busque instantáneamente en todos sus documentos.",
    ctaScan: "Escaneo Relámpago → Carpeta",
    ctaScanDesc: "Escanee y organice en un abrir y cerrar de ojos.",
  },
  testimonials: {
    badge: "Testimonios",
    title: "Confían en Nosotros",
    subtitle: "Descubra cómo nuestros clientes transforman su negocio con VEECTORIA",
    items: [
      { quote: "Gracias a VEECTORIA, redujimos tareas administrativas en un 70%.", metric: "-70%", metricLabel: "tiempo admin", name: "Isabelle G.", role: "Responsable Administrativa" },
      { quote: "El agente IA comercial transformó nuestra prospección. +40% citas cualificadas.", metric: "+40%", metricLabel: "citas cualificadas", name: "Marc D.", role: "Director Comercial" },
      { quote: "La solución documental nos ahorra tiempo precioso en gestión de expedientes.", metric: "5x", metricLabel: "más rápido", name: "Sophie M.", role: "Gerente" },
    ],
  },
  faq: {
    badge: "Preguntas Frecuentes",
    title: "Todo sobre VEECTORIA",
    subtitle: "Respuestas a sus preguntas más comunes",
    items: {
      q1: { question: "¿Qué es un Agente IA VEECTORIA?", answer: "Un colaborador virtual inteligente entrenado en sus procesos de negocio específicos." },
      q2: { question: "¿Cuánto tiempo tarda el despliegue?", answer: "El despliegue estándar toma 2-4 semanas, para necesidades más complejas 6-8 semanas." },
      q3: { question: "¿Mis datos están seguros?", answer: "Absolutamente. Todos los datos se alojan en Europa en servidores certificados, 100% conformes con RGPD." },
      q4: { question: "¿Cuál es el retorno de inversión esperado?", answer: "Nuestros clientes ven una ganancia de productividad del 40% y ROI positivo en 3 meses." },
      q5: { question: "¿Cómo funciona la integración?", answer: "VEECTORIA se integra nativamente con más de 200 herramientas profesionales." },
    },
  },
  contact: {
    badge: "Contáctenos",
    title: "¿Listo para Transformar su Empresa?",
    subtitle: "Hablemos de sus necesidades y descubra cómo VEECTORIA puede ayudarle",
    form: {
      name: "Nombre completo",
      email: "Email profesional",
      company: "Empresa",
      phone: "Teléfono",
      message: "Su mensaje",
      submit: "Enviar mensaje",
      sending: "Enviando...",
      success: "¡Mensaje enviado con éxito!",
      error: "Error al enviar. Por favor, inténtelo de nuevo.",
    },
    info: { title: "Información de Contacto", email: "Email", phone: "Teléfono", address: "Dirección" },
  },
  cta: {
    title: "¿Listo para Actuar?",
    subtitle: "Únase a las empresas que ya han transformado su productividad con VEECTORIA",
    button: "Reclutar un Agente IA",
  },
  footer: {
    description: "Soluciones de inteligencia artificial para transformar su empresa.",
    navigation: "Navegación",
    legal: "Aviso Legal",
    privacy: "Política de Privacidad",
    terms: "Términos y Condiciones",
    cookies: "Configuración de Cookies",
    rights: "Todos los derechos reservados.",
  },
  agents: {
    badge: "Nuestro Equipo",
    title: "Nuestros Agentes IA",
    subtitle: "Descubra nuestros colaboradores virtuales listos para unirse a su equipo",
  },

  // AI Agents Showcase
  agentsShowcase: {
    badge: "La Excelencia de la IA al Servicio de Su Empresa",
    title: "Nuestros Agentes IA Transforman Su Día a Día",
    description: "Imagine un equipo de colaboradores virtuales que nunca duerme, que aprende continuamente y que se adapta perfectamente a sus procesos de negocio. Nuestros Agentes IA aumentan sus capacidades, liberan a sus talentos de tareas repetitivas y llevan su productividad a nuevas alturas.",
    imageAlt: "Equipo de Agentes IA VEECTORIA",
    cta: "Descubrir Nuestros Agentes",
    benefits: {
      availability: "Disponibles 24/7",
      productivity: "Productividad x10",
      performance: "Rendimiento Óptimo",
      collaboration: "Colaboración Fluida",
    },
  },
  cookies: {
    title: "Gestión de cookies",
    message: "Utilizamos cookies para mejorar su experiencia en nuestro sitio, analizar el tráfico y personalizar el contenido.",
    accept: "Aceptar todo",
    decline: "Rechazar",
    settings: "Personalizar",
    settingsTitle: "Configuración de cookies",
    settingsDescription: "Gestione sus preferencias de cookies. Las cookies esenciales son necesarias para el funcionamiento del sitio y no pueden desactivarse.",
    saveChoices: "Guardar mis elecciones",
    rejectAll: "Rechazar todo",
    alwaysActive: "Siempre activo",
    categories: {
      essential: { name: "Cookies esenciales", description: "Estas cookies son necesarias para el funcionamiento del sitio y no pueden desactivarse." },
      analytics: { name: "Cookies analíticas", description: "Estas cookies nos permiten medir la audiencia del sitio y analizar el comportamiento de navegación." },
      marketing: { name: "Cookies de marketing", description: "Estas cookies se utilizan para ofrecer anuncios personalizados." },
      preferences: { name: "Cookies de preferencias", description: "Estas cookies recuerdan sus preferencias (idioma, tema, región)." },
    },
  },

  // Partners Section
  partners: {
    badge: "Programa de Socios",
    title: "Desarrollemos Juntos",
    description: "¿Es usted revendedor, distribuidor, editor de software o mayorista? VEECTORIA se convierte en su socio tecnológico preferido para conquistar nuevos mercados con soluciones de inteligencia artificial de vanguardia.",
    valueProposition: "Diseñamos y desarrollamos soluciones profesionales completas y personalizadas para sus clientes, mientras le apoyamos en la implementación de una estrategia de comercialización masiva. Márgenes atractivos, soporte técnico dedicado y asistencia de marketing: todos los ingredientes para su éxito.",
    types: {
      resellers: { title: "Revendedores", description: "Integre nuestras soluciones de IA en su catálogo y ofrezca paquetes diferenciadores." },
      distributors: { title: "Distribuidores", description: "Despliegue nuestras tecnologías a gran escala en su territorio." },
      editors: { title: "Editores de Software", description: "Mejore su software con nuestra IA para un valor añadido incomparable." },
      wholesalers: { title: "Mayoristas", description: "Acceda a tarifas preferenciales para distribución masiva en sus redes." },
    },
    benefits: {
      title: "Sus Beneficios de Socio",
      whiteLabel: "Soluciones marca blanca",
      support: "Soporte técnico dedicado",
      scalability: "Escalabilidad ilimitada",
    },
    cta: "Conviértase en Socio",
    ctaSubtext: "Contáctenos para descubrir nuestro programa exclusivo de socios",
  },

  legal: {
    lastUpdate: "Última actualización: Enero 2026",
    mentions: {
      title: "Aviso Legal",
      sections: {
        editor: { title: "1. Editor del sitio", intro: "Este sitio es editado por:", companyName: "Razón social", legalForm: "Forma jurídica", capital: "Capital social", address: "Domicilio social", siren: "SIREN", siret: "SIRET", rcs: "RCS", tva: "NIF-IVA", naf: "Código NAF" },
        publication: { title: "2. Director de publicación", intro: "La publicación está dirigida por:", since: "desde" },
        contact: { title: "3. Contacto", phone: "Teléfono", email: "Email" },
        hosting: { title: "4. Alojamiento", intro: "El sitio está alojado por:", name: "Nombre", address: "Dirección" },
        intellectual: { title: "5. Propiedad intelectual", content1: "Este sitio está sujeto a la legislación francesa e internacional sobre derechos de autor y propiedad intelectual.", content2: "La reproducción de este sitio, total o parcial, está estrictamente prohibida sin autorización expresa de" },
        liability: { title: "6. Limitación de responsabilidad", content: "La información en este sitio es lo más precisa posible. {company} no puede ser responsable de daños directos o indirectos derivados del uso de este sitio." },
        law: { title: "7. Ley aplicable", content: "Este sitio está sujeto a la ley francesa. En caso de litigio, los tribunales franceses serán los únicos competentes." },
      },
    },
    privacy: {
      title: "Política de Privacidad",
      sections: {
        intro: { title: "1. Introducción", content: "{company} se compromete a proteger la privacidad de los usuarios de su sitio web. Esta política explica cómo recopilamos, utilizamos y protegemos sus datos personales de acuerdo con el RGPD." },
        controller: { title: "2. Responsable del tratamiento", company: "Empresa", address: "Dirección", email: "Email" },
        data: { title: "3. Datos recopilados", intro: "Recopilamos los siguientes datos:", items: ["Datos de identificación: nombre, apellido, email, teléfono", "Datos profesionales: empresa, cargo", "Datos de navegación: dirección IP, cookies, páginas visitadas", "Datos de comunicación: mensajes vía formularios"] },
        purposes: { title: "4. Finalidades del tratamiento", intro: "Sus datos se recopilan para:", items: ["Responder a sus solicitudes de contacto", "Proporcionar nuestros servicios de IA", "Mejorar nuestro sitio", "Enviar comunicaciones comerciales (con su consentimiento)", "Cumplir obligaciones legales"] },
        basis: { title: "5. Base legal", intro: "El tratamiento se basa en:", items: ["Su consentimiento explícito", "Ejecución de contrato", "Nuestro interés legítimo", "Obligaciones legales"] },
        retention: { title: "6. Período de conservación", content: "Sus datos se conservan durante el tiempo necesario, máximo 3 años tras su último contacto." },
        rights: { title: "7. Sus derechos", intro: "De acuerdo con el RGPD, tiene los siguientes derechos:", access: "Derecho de acceso", accessDesc: "obtener una copia de sus datos", rectification: "Derecho de rectificación", rectificationDesc: "corregir datos inexactos", erasure: "Derecho de supresión", erasureDesc: "solicitar eliminación de sus datos", restriction: "Derecho de limitación", restrictionDesc: "limitar el tratamiento", portability: "Derecho de portabilidad", portabilityDesc: "recibir datos en formato estructurado", objection: "Derecho de oposición", objectionDesc: "oponerse al tratamiento", contact: "Para ejercer estos derechos, contáctenos:" },
        security: { title: "8. Seguridad", content: "Implementamos medidas técnicas y organizativas adecuadas para proteger sus datos." },
        complaint: { title: "9. Reclamación", content: "Puede presentar una reclamación ante la CNIL: www.cnil.fr" },
      },
    },
    cgv: {
      title: "Términos y Condiciones",
      sections: {
        object: { title: "1. Objeto", content: "Estos Términos regulan las relaciones contractuales entre {company} y sus clientes para servicios de IA, desarrollo de software y soluciones empresariales." },
        provider: { title: "2. Proveedor", company: "Empresa", siret: "SIRET", address: "Dirección" },
        services: { title: "3. Servicios ofrecidos", intro: "{company} ofrece los siguientes servicios:", items: ["Agentes IA especializados", "Aplicaciones empresariales personalizadas (Prime Evolution)", "Soluciones de IA documental", "VEECTORIA Pulse - Plataforma de transcripción", "Consultoría e integración de IA"] },
        quotes: { title: "4. Presupuestos y pedidos", content: "Todos los servicios están sujetos a un presupuesto detallado." },
        pricing: { title: "5. Precios y pago", content1: "Precios en euros sin IVA. IVA del 20%. Pagadero en 30 días.", content2: "En caso de retraso, se aplicarán intereses de demora." },
        delivery: { title: "6. Entrega y plazos", content: "Los plazos son indicativos. {company} se compromete a respetar los plazos acordados." },
        intellectual: { title: "7. Propiedad intelectual", content: "Los desarrollos permanecen propiedad de {company} hasta el pago completo." },
        confidentiality: { title: "8. Confidencialidad", content: "Ambas partes se comprometen a la confidencialidad durante 3 años tras el fin del contrato." },
        liability: { title: "9. Limitación de responsabilidad", content: "La responsabilidad de {company} está limitada al valor del contrato." },
        law: { title: "10. Ley aplicable", content: "Se aplica la ley francesa. El tribunal competente es París." },
      },
    },
    cookiesPolicy: {
      title: "Política de Cookies",
      sections: {
        what: { title: "1. ¿Qué es una cookie?", content: "Una cookie es un pequeño archivo de texto que se coloca en su dispositivo al visitar un sitio web." },
        types: { title: "2. Cookies utilizadas", intro: "Nuestro sitio utiliza las siguientes cookies:", essential: "Cookies esenciales", essentialDesc: "Necesarias para el funcionamiento del sitio.", analytics: "Cookies analíticas", analyticsDesc: "Nos ayudan a entender el uso.", preferences: "Cookies de preferencias", preferencesDesc: "Recuerdan sus elecciones." },
        retention: { title: "3. Período de conservación", content: "Las cookies se conservan un máximo de 13 meses." },
        management: { title: "4. Gestión de cookies", intro: "Puede cambiar sus preferencias en cualquier momento:", items: ["Chrome: Configuración → Privacidad → Cookies", "Firefox: Opciones → Privacidad → Cookies", "Safari: Preferencias → Privacidad → Cookies", "Edge: Configuración → Cookies"] },
        contact: { title: "5. Contacto", content: "Para preguntas sobre cookies, contáctenos:" },
      },
    },
  },
};
